module.exports = __webpack_public_path__ + "static/media/figma-grid-download.91d176a9.jpg";